import React from "react";

import "./Loading.css";
// import "../App.css"

class Loading extends React.Component {

	render() {
		return (
			<div className="Loading">
				<div className="loadingIcon">
					<div className="loadingAnim play"></div>
					
				</div>
				<div className="loadingText">loading...</div>
				
			</div>
		);
	}
}

export default Loading;



// WEBPACK FOOTER //
// ./src/views/Loading.js